export default "__VITE_PUBLIC_ASSET__08533053__"